<template>
  <div class="mt-2 space-y-4">
    <div>
      <label for="description" class="text-lg font-medium">Description</label>
      <el-input
        type="textarea"
        id="description"
        class="mt-2 w-full"
        :rows="6"
        :value="value"
        @input="$emit('input', $event)"
        placeholder="Enter description here..."
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "EditKnowledgeSettingsSimple",
  components: {},
  emits: ["input"],
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    updateValue(value) {
      this.emit("input", value);
    },
  },
};
</script>
